import { createFileRoute } from '@tanstack/react-router'
import { Gauge } from 'lucide-react'
import { StatusScreen } from '@/screens/help/SCR-178-179-status'

// SCR-178 System status (help area).
export const Route = createFileRoute('/_app/help/status')({
  staticData: { screen: { id: 'SCR-178', title: 'System status', group: 'Help', order: 4, description: 'Whether ESM is working normally, and what we are doing when it isn’t.', icon: Gauge } },
  component: StatusScreen,
})
